var map = {
	"./SFI-Logo.png": "MTBZ",
	"./SFM-Logo.png": "/Hf5",
	"./SFM-Logo_2x.png": "vCZq",
	"./headerPhoneIcon.png": "70zk",
	"./sfi-header-logo.png": "iwCO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "h+qC";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header nonrecursive \.png$
// module id = h+qC
// module chunks = 1